import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaymentStore } from 'src/app/features/payment/public/report/store/payment-report.store';
import { PaymentService } from 'src/app/services/payment.service';
import { ToastrFactoryService } from 'src/app/services/toastr-factory.service';
import { constructTutorialUrl } from 'src/app/utils/link-utils';
import { MatTooltip } from '@angular/material/tooltip';
import getFromClipboardUtils from 'src/app/utils/try-to-read-clipboard-utils';
import { ClipboardPermissionDirective } from 'src/app/directive/can-read-from-clipboard.directive';
import { formatNetworkName } from 'src/app/utils/network-utils';
import { PaymentUtils } from 'src/app/features/payment/public/report/utils/payment-utils';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';

@Component({
  selector: 'app-transaction-id-input-modal',
  imports: [CommonModule, FormsModule, TranslateModule, MatTooltip, ClipboardPermissionDirective, ModalBaseComponent],
  templateUrl: './transaction-id-input-modal.component.html',
})
export class TransactionIdInputModalComponent {
  protected dialogRef = inject(DialogRef);
  protected paymentService = inject(PaymentService);
  protected toastrFactory = inject(ToastrFactoryService);
  protected paymentStore = inject(PaymentStore);
  protected translate = inject(TranslateService);
  protected readFromClipboardUtils = inject(getFromClipboardUtils);
  protected paymentUtils = inject(PaymentUtils);
  protected data = inject(DIALOG_DATA);

  public transactionId: string | undefined = this.paymentStore?.paymentDetails?.()?.transactionId;

  public payment: FormGroup = new FormGroup({
    transactionId: new FormControl(this.transactionId, [Validators.required, Validators.pattern('^.+$')]),
  });

  pasteTransactionId() {
    this.tryToReadClipboard();
  }

  updateTransactionId() {
    this.paymentStore.updatePaymentDetails({ transactionId: this.transactionId });
  }

  async tryToReadClipboard() {
    try {
      const transactionId = await navigator.clipboard.readText();
      this.transactionId = transactionId.trim();
    } catch (e: any) {
      console.log(e);
      this.toastrFactory.error(this.translate.instant('permissionToReadFromYourClipboardHasBeenDenied'));
      return;
    }
  }

  getInformingPhrase() {
    const targetWebsitePath = '/support/how-to-find-a-transaction-id';
    const defaultLang = localStorage.getItem('defaultLang');
    const currentNetwork = this.paymentStore.paymentDetails().payingAsset?.assetChain || '';

    const tutorialUrl = constructTutorialUrl(targetWebsitePath, defaultLang);

    return this.translate.instant('theTransactionIdHelpsUsVerifying', {
      asset: this.paymentStore.paymentDetails().payingAsset?.assetTicker,
      network: this.translate.instant(formatNetworkName(currentNetwork).toLocaleLowerCase() + 'Network'),
      tutorialLink: tutorialUrl,
    });
  }

  finishTransaction() {
    if (!this.transactionId?.trim()) return;

    this.paymentStore.updatePaymentDetails({ transactionId: this.transactionId });

    this.dialogRef.close(true);
  }
}
